import React from 'react'

export default function Personal() {
    return (
        <div>
            <h2>About Me</h2>

            <p>
                Hello! I am a software engineer who enjoys solving complex problems across the full technology stack.
                I adapt quickly to new languages, frameworks, and tools as needed — whether it's web development,
                mobile apps, embedded systems, or RF technologies.
            </p>

            <p>
                Over the past 7+ years, I've worked on projects ranging from enterprise resource planning systems
                to defense sector spectrum management tools. I believe in learning whatever is necessary to get the job done right.
            </p>

            <h3>Education</h3>
            <p>
                BSc in Software Engineering<br />
                Addis Ababa Science and Technology University
            </p>

            <h3>Technologies I've Worked With</h3>
            <p>
                TypeScript, JavaScript, C++, Java, Python, React, React Native, Node.js, Android,
                GraphQL, REST APIs, MongoDB, PostgreSQL, MySQL, Firebase, Git, Linux, Docker, AWS,
                Embedded Systems, RF Signal Processing, Software-Defined Radio (SDR)
            </p>

            <hr />

            <h3>Links</h3>
            <ul>
                <li><a href="https://github.com/AbrahamTerfie" target="_blank" rel="noreferrer">GitHub</a></li>
                <li><a href="https://www.linkedin.com/in/abraham-terfie/" target="_blank" rel="noreferrer">LinkedIn</a></li>
                <li><a href={require('../Assets/abrahamtworkie23.pdf')} download="abrahamtworkie23.pdf">Download CV (PDF)</a></li>
            </ul>
        </div>
    )
}
